exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AppLinkSender-title{font-size:16px;font-weight:500;margin-bottom:16px}", ""]);

// exports
